import React, { useState } from "react";
import { CardElement } from "@stripe/react-stripe-js";

const PaymentForm = ({ onSubmit, isLoading, planAmount, selectedPlanName }) => {
    const [cardError, setCardError] = useState(null);
    const [cardComplete, setCardComplete] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setCardError(null);

        if (!cardComplete) {
            setCardError("Please complete your card details.");
            return;
        }

        await onSubmit();
    };

    const handleCardChange = (event) => {
        setCardError(event.error ? event.error.message : null);
        setCardComplete(event.complete);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-4">
                <div className="alert alert-info d-flex align-items-center" role="alert">
                    <i className="fas fa-info-circle me-2"></i>
                    <div>
                        <strong>Subscribing to:</strong> {selectedPlanName}
                        <br />
                        <strong>Amount:</strong> ${planAmount?.toFixed(2)} USD/month
                    </div>
                </div>
            </div>

            <div className="mb-3">
                <label className="form-label fw-semibold">
                    <i className="fas fa-credit-card me-2"></i>
                    Card Details
                </label>
                <div
                    className={`form-control p-3 ${cardError ? "is-invalid" : ""}`}
                    style={{
                        height: "auto",
                        minHeight: "45px",
                        backgroundColor: "#f8f9fa",
                        border: cardError ? "1px solid #dc3545" : "1px solid #dee2e6",
                    }}
                >
                    <CardElement
                        options={{
                            style: {
                                base: {
                                    fontSize: "16px",
                                    color: "#32325d",
                                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                                    "::placeholder": {
                                        color: "#aab7c4",
                                    },
                                },
                                invalid: {
                                    color: "#fa755a",
                                    iconColor: "#fa755a",
                                },
                            },
                            hidePostalCode: false,
                        }}
                        onChange={handleCardChange}
                    />
                </div>
                {cardError && (
                    <div className="invalid-feedback d-block">
                        <i className="fas fa-exclamation-circle me-1"></i>
                        {cardError}
                    </div>
                )}
                <small className="form-text text-muted mt-2 d-block">
                    <i className="fas fa-lock me-1"></i>
                    Your payment information is encrypted and secure
                </small>
            </div>

            <div className="d-grid gap-2">
                <button
                    type="submit"
                    disabled={isLoading || !cardComplete}
                    className="btn btn-primary btn-lg fw-bold"
                >
                    {isLoading ? (
                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                            />
                            Processing Payment...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-lock me-2"></i>
                            Pay ${planAmount?.toFixed(2)} & Subscribe
                        </>
                    )}
                </button>
            </div>

            <div className="text-center mt-3">
                <small className="text-muted">
                    <i className="fas fa-shield-alt me-1"></i>
                    Secured by Stripe • No commitment • Cancel anytime
                </small>
            </div>
        </form>
    );
};

export default PaymentForm;
